export default __webpack_public_path__ + "static/media/feature-network.6c909e1d.svg";